import { render, staticRenderFns } from "./CitationsBadge.vue?vue&type=template&id=68073a97"
import script from "./CitationsBadge.vue?vue&type=script&lang=js"
export * from "./CitationsBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports